import { COLOR1, COLOR4, RADIO_COLOR, WHITE } from '../../constants';

export const AddressEditModalStyles = {
  productmodalclose: {
    width: '25px',
    height: '25px',
  },

  radioLabelCommon: {
    marginBottom: '20px',
    display: 'flex',
    width: '100%',
  },
  radioLabel: {
    alignItems: 'center',
  },
  radioLabelBundle: {
    alignItems: 'flex-start',
  },

  productmodalcontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  productmodal: {
    outline: 'none',
  },

  backdrop: {
    zIndex: 1301,
    color: WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '398px',
    // background: '#FFFFFF',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    borderRadius: '10px',
    '@media (max-width:600px)': {
      width: '420px',
      maxWidth: 'none',
      borderRadius: '60px 60px 0 0',
    },
    '@media (max-width:400px)': {
      width: '375px',
      maxWidth: 'none',
      borderRadius: '78px 78px 0 0',
    },
    '@media (max-width:380px)': {
      width: '376px',
      borderRadius: '78px 78px 0 0',
    },
    '@media (max-width:281px)': {
      width: '330px',
      borderRadius: '78px 78px 0 0',
    },
  },
  rootBundle: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '398px',
    padding: '30px',
    // background: '#FFFFFF',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    borderRadius: '24px',
    '@media (max-width:600px)': {
      width: '272px',
      maxWidth: 'none',
    },
  },
  card_content: {
    textAlign: 'center',
    padding: '0px !important',
  },

  radioLayout: {
    marginTop: '27px',
    marginBottom: '30px',
    marginLeft: '58px',
    '@media (max-width:600px)': {
      marginTop: '20px',
      marginBottom: '20px',
      marginLeft: '46px',
    },
    '@media (max-width:407px)': {
      marginLeft: '32px',
    },
  },

  radioLayout_es: {
    marginTop: '27px',
    marginBottom: '15px',
    marginLeft: '40px',
    '@media (max-width:600px)': {
      marginTop: '20px',
      marginBottom: '15px',
      marginLeft: '55px',
    },
  },
  radioLayoutBundle: {
    marginTop: '24px',
    marginBottom: '24px',
  },

  radioLayout_esBundle: {
    marginTop: '24px',
    marginBottom: '24px',
  },
  radioRoot: {
    width: 0,
    height: '19px',
    paddingTop: 0,
    paddingBottom: 0,
  },

  radioLabelStyle: {
    marginLeft: '15px',
    font: 'normal 400 16px/18px Arial',
    display: 'inline',
    color: '#000000',
    cursor: 'pointer',
    '@media (max-width:310px)': {
      font: 'normal 400 15px/17px Arial',
      marginLeft: '3px',
      marginRight: '65px',
    },
  },
  radioLabelStyleBundle: {
    gap: '8px',
    marginLeft: '15px',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    // font: 'normal 400 16px/18px Arial',
    fontWeight: 700,
    cursor: 'pointer',
    '@media (max-width:310px)': {
      font: 'normal 400 15px/17px Arial',
      marginLeft: '3px',
      marginRight: '65px',
    },
  },

  saveAndExit: {
    letterSpacing: '0.1px',
    font: 'normal 700 14px/16px Arial',
    width: '136px',
    height: '44px',
    margin: '17px 0 30px 0',
    opacity: 1,
    textTransform: 'none',
    borderRadius: '56px',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  saveAndExitBundle: {
    letterSpacing: '0.1px',
    font: 'normal 700 14px/16px Arial',
    width: '100%',
    maxWidth: '420px',
    height: '40px',
    opacity: 1,
    textTransform: 'none',
    borderRadius: '56px',
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
  },
  close: {
    letterSpacing: '0.1px',
    font: 'normal 700 14px/16px Arial',
    width: '100%',
    maxWidth: '204px',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 1,

    textTransform: 'none',
    borderRadius: '56px',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    alignSself: 'stretch',
  },
  textOneStyle: {
    font: 'normal 700 24px/28px Arial',
    marginTop: '38px',
    marginLeft: '67px',
    marginRight: '60px',
    '@media (max-width:400px)': {
      marginLeft: '49px',
      marginRight: '49px',
      width: '284px',
    },
    '@media (max-width:281px)': {
      marginLeft: '38px',
      marginRight: '25px',
      width: '299px',
    },
  },
  textOneStyleBundle: {
    font: 'normal 700 24px/normal TTNORMSPROBOLD',
    margin: '0 !important',
    '@media (max-width:400px)': {
      width: '284px',
    },
    '@media (max-width:281px)': {
      width: '299px',
    },
  },
  reason: {
    font: 'normal 700 16px/18px Arial',
    color: COLOR1,
    marginTop: '20px',
    marginLeft: '0px',
    paddingRight: '125px',
  },

  reason_es: {
    font: 'normal 700 16px/18px Arial',
    color: COLOR1,
    marginTop: '20px',
    marginLeft: '0px',
    paddingRight: '0px',
    '@media (max-width:600px)': {
      marginLeft: '21px',
      paddingRight: '0px',
    },
  },

  close_icon: {
    width: '34px',
    height: '34px',
    cursor: 'pointer',
    margin: '5px 5px 0 0',
  },

  modal_close: {
    color: RADIO_COLOR,
    textAlign: 'right',
    height: '35px',
  },

  closeOverlay: {
    padding: 0,
    top: '29px',
    color: COLOR4,
    width: '44px',
    cursor: 'pointer',
    height: '28px',
    position: 'relative',
  },
  iconstyle: {
    marginTop: '10px',
  },
  subtext: {
    textAlign: 'center',
    lineHeight: '32px',
    '@media (max-width:600px)': {
      lineHeight: 'normal',
      marginTop: '10px',
    },
  },
};
